// Module
var code = "<!--ko with: _viewModel--> <!--ko template: {html: GetTemplate}--><!--/ko--> <!--/ko--> ";
// Exports
export default code;